<div style="margin-top: 30px; margin-bottom: 30px;" class="container" *ngIf="!success && practitioner | async; let prac">
  <form [formGroup]="testimonialForm" (ngSubmit)="onSubmit()">
    <div class="card">
      <div class="card-body">
        <h5 class="card-title">
          How would you rate your overall experience with {{ prac.getFullName() }}?
        </h5>
        <div class="d-flex flex-fill">
          <img alt="" height="152" width="152" [src]="prac.profileImage">
          <div>
            <label for="rating">Select your star rating</label>
            <app-rating-selector (setRating)="updateRating($event)"></app-rating-selector>
          </div>
        </div>
      </div>
    </div>
    <div class="card" style="margin-top: 30px;">
      <div class="card-body">
        <h5 class="card-title mb-4">
          What did you like about working with {{ prac.getFullName() }}?
        </h5>
        <div class="card-subtitle">
          <div class="d-flex flex-fill align-items-end" style="margin: 15px auto;">
            <div class="card-subtitle d-flex flex-wrap">
              <span
                (click)="onValueSelected(i)"
                class="card-pill mb-2"
                [ngClass]="{active: value.selected}"
                *ngFor="let value of values; let i = index"
                triggers="mouseenter:mouseleave"
                ngbPopover="{{value.details}}">
                {{value.name}}
              </span>
            </div>
          </div>
          <span
            class="help-block"
            *ngIf="testimonialForm.get('values').touched && valuesCount === 0">
              Please select at least one.
          </span>
          <div class="row">
            <div class="col-xs-12 col-md-8">
              <div class="form-group">
                <label for="description">Write a review</label>
                <textarea type="text" class="form-control" id="description" rows="4" formControlName="description"></textarea>
                <span
                  class="help-block"
                  *ngIf="testimonialForm.get('description').invalid && testimonialForm.get('description').touched">
                    Please enter a valid review.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card" style="margin-top: 30px;">
      <div class="card-body">
        <h5 class="card-title">Enter your information</h5>
        <div class="row">
          <div class="col-xs-12 col-md-6">
            <div class="form-group">
              <label for="firstName">First name</label>
              <input type="text" class="form-control" formControlName="firstName">
              <span
                class="help-block"
                *ngIf="testimonialForm.get('firstName').invalid && testimonialForm.get('firstName').touched">
                  Please enter a valid first name.
              </span>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-group">
              <label for="firstName">Last name</label>
              <input type="text" class="form-control" formControlName="lastName">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-md-6">
            <div class="form-group">
              <label for="firstName">Email</label>
              <input type="email" class="form-control" formControlName="email">
              <span
                class="help-block"
                *ngIf="testimonialForm.get('email').invalid && testimonialForm.get('email').touched">
                  Please enter a valid email.
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="error" class="alert alert-danger" style="margin-top: 30px;">
      <span>{{error}}</span>
    </div>

    <div class="row" style="margin-top: 30px;">
      <div class="col-xs-12 col-md-6 form-group d-flex">
        <button class="btn btn-primary flex-fill" type="submit" [disabled]="testimonialForm.invalid || valuesCount === 0 || disableSubmit">Submit Testimonial</button>
        <app-loader *ngIf="isLoading"></app-loader>
      </div>
    </div>
  </form>
</div>

<div *ngIf="success" class="alert alert-success" style="margin-top: 30px;">
  <span>{{success}}</span>
</div>
